import { Injectable } from '@angular/core';
import { AdminPatientServices } from '@services/admin/admin-patient.service';

import { BehaviorSubject, catchError, EMPTY, Observable, ReplaySubject, Subject, switchMap, tap } from 'rxjs';
import { Patient, PatientNote } from 'src/app/models/patient';
@Injectable({
    providedIn: 'root',
})
export class PatientStateService {
    constructor(private patientServices: AdminPatientServices) {
        // switchMap cancels the previous in-flight HTTP request whenever a new id is pushed,
        // preventing a slow response for patient A from overwriting the data for patient B.
        this.patientLoadTrigger$
            .pipe(
                switchMap((id) =>
                    this.setSummaryPatientData$(id).pipe(
                        catchError((error) => {
                            console.error('Unable to load patient trial summary', error);
                            return EMPTY;
                        })
                    )
                )
            )
            .subscribe();
        //no takeUntil needed.
        // All three services are providedIn: 'root', meaning Angular creates a single instance
        //  that lives for the entire application lifetime.
        //  There is no destroy event to react to; the instance is only ever garbage-collected
        //  when the browser tab closes, at which point all subscriptions are torn down by the runtime anyway.
    }

    private readonly patient = new ReplaySubject<Patient>(1);
    public readonly patient$ = this.patient.asObservable();
    private readonly patientLoadTrigger$ = new Subject<number>();
    public readonly patientNotes = new BehaviorSubject<PatientNote[]>([]);

    public setNewPatient(newPatient: Patient): void {
        this.patientNotes.next([]);
        this.patient.next(newPatient);
    }

    public setSummaryPatientData(id: number): void {
        this.patientLoadTrigger$.next(id);
    }

    private setSummaryPatientData$(id: number) {
        return this.patientServices.getPatientTrialSummary(id).pipe(
            tap((res) => {
                this.patientNotes.next(res?.patientNotes ?? []);
                this.patient.next(res);
            })
        );
    }

    public getSummaryPatientData(): Observable<Patient> {
        return this.patient$;
    }

    clearStore() {
        this.patient.next(null);
    }
    public getPatient() {
        return this.patient$;
    }

    //when crc then notes cannot be added
    public getPatientNotesFormData(): PatientNote[] {
        return this.patientNotes ? this.patientNotes.value : [];
    }
}
